import { ricsAndCompanyBranchLabels } from '../constants/branch-labels';
import { defineTreeFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const competitorsDescriptor = defineTreeFilter({
  definition: {
    id: FilterId.COMPETITORS,
    name: 'Competitors',
    selectionListIds: ['rics_k10', 'rics_k400', 'company'],
    selections: [],
    branches: ricsAndCompanyBranchLabels,
    type: FilterType.TREE,
    isVisible: true,
  },
});
